import React from "react";
import { NAV_TYPE_TOP } from "constants/ThemeConstant";
import { APP_NAME, PUBLIC_PREFIX_PATH } from "configs/AppConfig";
import { connect } from "react-redux";
import utils from "utils";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
	const { navCollapsed, navType } = props;
	const isNavTop = navType === NAV_TYPE_TOP ? true : false;
	if (isMobile && !props.mobileLogo) {
		return 0;
	}

	if (isNavTop) {
		return "auto";
	}
	if (navCollapsed) {
		return `100%`;
	} else {
		return `100%`;
	}
};

const getLogo = (props) => {
	const { navCollapsed, logoType } = props;
	if (logoType === "light") {
		if (navCollapsed) {
			return `${PUBLIC_PREFIX_PATH}/novo-logo-curto.png`;
		}
		return `${PUBLIC_PREFIX_PATH}/logo-claro.png`;
	}

	if (navCollapsed) {
		return `${PUBLIC_PREFIX_PATH}/novo-logo-curto.png`;
	}
	return `${PUBLIC_PREFIX_PATH}/logo-claro.png`;
};

const getLogoDisplay = (isMobile, mobileLogo) => {
	if (mobileLogo) {
		return "logo-mobile";
	}
	if (isMobile && !mobileLogo) {
		return "d-none";
	} else {
		return "logo";
	}
};

export const Logo = (props) => {
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
	return (
		<div
			className={getLogoDisplay(isMobile, props.mobileLogo)}
			style={{
				width: `${getLogoWidthGutter(props, isMobile)}`,
				padding: 0,
				transition: "all 0.2s ease",
			}}
		>
			<img
				src={getLogo(props)}
				alt={`${APP_NAME} logo`}
				width="100%"
				height="100%"
				style={{
					objectFit: "contain",
				}}
			/>
		</div>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, navType } = theme;
	return { navCollapsed, navType };
};

export default connect(mapStateToProps)(Logo);
